import { refreshUserCats } from "@/hooks/useUserCats";
import { refreshGlobalStats } from "@/hooks/useGlobalStats";
import { refreshCatDetails } from "@/hooks/useCatDetails";
import { refreshCatclawBalance } from "@/hooks/useCatclawBalance";
import { refreshEthBalance } from "@/hooks/useEthBalance";

/**
 * 交易成功后统一刷新链上数据。
 *
 * 页面已完全取消定时轮询，因此每笔交易之后必须主动拉一次，
 * 否则界面会一直停留在旧数据上。集中到一个函数有三个好处：
 * 1. 不会漏刷（此前 Upgrade 燃烧了 $CATCLAW 却不更新余额，Split / Claim 完全不刷新）；
 * 2. 所有请求在同一个事件循环内发出，被 ethers 合并成一个 JSON-RPC batch；
 * 3. 新增操作面板时只需调用这一个函数。
 *
 * @param tokenId 本次操作涉及的猫；传入则一并刷新其详情
 */
export async function refreshAfterTx(tokenId?: number | null): Promise<void> {
  await Promise.all([
    refreshUserCats(),
    refreshGlobalStats(),
    refreshCatclawBalance(),
    refreshEthBalance(),
    tokenId ? refreshCatDetails(tokenId) : Promise.resolve(),
  ]);
}
